var _path, _path2, _circle, _path3, _path4, _path5, _path6, _circle2, _path7, _path8, _path9, _path10, _circle3, _path11, _path12, _path13, _path14, _circle4, _path15, _path16, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgActivityComingSoon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 269,
    height: 105,
    viewBox: "0 0 269 105",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.0827 53.1395C56.0827 50.0139 55.4671 46.919 54.271 44.0314C53.075 41.1438 51.3218 38.5201 49.1118 36.31C46.9017 34.1 44.278 32.3468 41.3904 31.1507C38.5028 29.9547 35.4079 29.3391 32.2823 29.3391C29.1568 29.3391 26.0619 29.9547 23.1743 31.1507C20.2867 32.3468 17.663 34.1 15.4529 36.31C13.2428 38.5201 11.4897 41.1438 10.2936 44.0314C9.09755 46.919 8.48193 50.0139 8.48193 53.1395L32.2823 53.1395H56.0827Z",
    fill: "url(#paint0_linear_187_1802)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M56.0827 53.1395C56.0827 50.0139 55.4671 46.919 54.271 44.0314C53.075 41.1438 51.3218 38.5201 49.1118 36.31C46.9017 34.1 44.278 32.3468 41.3904 31.1507C38.5028 29.9547 35.4079 29.3391 32.2823 29.3391C29.1568 29.3391 26.0619 29.9547 23.1743 31.1507C20.2867 32.3468 17.663 34.1 15.4529 36.31C13.2428 38.5201 11.4897 41.1438 10.2936 44.0314C9.09755 46.919 8.48193 50.0139 8.48193 53.1395L32.2823 53.1395H56.0827Z",
    fill: "black",
    fillOpacity: 0.1
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32.283,
    cy: 21.406,
    r: 15.8669,
    fill: "#619D94"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.8094 32.3152C40.9175 35.369 36.8246 37.274 32.2867 37.274C27.749 37.274 23.6561 35.3691 20.7642 32.3153C21.545 31.8833 22.3511 31.4946 23.1789 31.1518C26.0665 29.9557 29.1614 29.3401 32.2869 29.3401C35.4124 29.3401 38.5073 29.9557 41.3949 31.1518C42.2226 31.4946 43.0286 31.8832 43.8094 32.3152Z",
    fill: "url(#paint1_linear_187_1802)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.8094 32.3152C40.9175 35.369 36.8246 37.274 32.2867 37.274C27.749 37.274 23.6561 35.3691 20.7642 32.3153C21.545 31.8833 22.3511 31.4946 23.1789 31.1518C26.0665 29.9557 29.1614 29.3401 32.2869 29.3401C35.4124 29.3401 38.5073 29.9557 41.3949 31.1518C42.2226 31.4946 43.0286 31.8832 43.8094 32.3152Z",
    fill: "black",
    fillOpacity: 0.1
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M122.251 94.3265C122.251 91.201 121.636 88.1061 120.44 85.2185C119.243 82.3309 117.49 79.7072 115.28 77.4971C113.07 75.287 110.446 73.5339 107.559 72.3378C104.671 71.1417 101.576 70.5261 98.4508 70.5261C95.3253 70.5261 92.2304 71.1417 89.3428 72.3378C86.4552 73.5339 83.8314 75.287 81.6214 77.4971C79.4113 79.7072 77.6582 82.3309 76.4621 85.2185C75.266 88.1061 74.6504 91.201 74.6504 94.3265L98.4508 94.3265H122.251Z",
    fill: "url(#paint2_linear_187_1802)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M122.251 94.3265C122.251 91.201 121.636 88.1061 120.44 85.2185C119.243 82.3309 117.49 79.7072 115.28 77.4971C113.07 75.287 110.446 73.5339 107.559 72.3378C104.671 71.1417 101.576 70.5261 98.4508 70.5261C95.3253 70.5261 92.2304 71.1417 89.3428 72.3378C86.4552 73.5339 83.8314 75.287 81.6214 77.4971C79.4113 79.7072 77.6582 82.3309 76.4621 85.2185C75.266 88.1061 74.6504 91.201 74.6504 94.3265L98.4508 94.3265H122.251Z",
    fill: "black",
    fillOpacity: 0.1
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 98.4509,
    cy: 62.5931,
    r: 15.8669,
    fill: "#619D94"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M109.977 73.5013C107.085 76.5551 102.993 78.4599 98.4548 78.4599C93.917 78.4599 89.8241 76.555 86.9321 73.5012C87.7129 73.0692 88.5189 72.6806 89.3466 72.3377C92.2342 71.1416 95.3291 70.526 98.4546 70.526C101.58 70.526 104.675 71.1416 107.563 72.3377C108.39 72.6806 109.196 73.0693 109.977 73.5013Z",
    fill: "url(#paint3_linear_187_1802)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M109.977 73.5013C107.085 76.5551 102.993 78.4599 98.4548 78.4599C93.917 78.4599 89.8241 76.555 86.9321 73.5012C87.7129 73.0692 88.5189 72.6806 89.3466 72.3377C92.2342 71.1416 95.3291 70.526 98.4546 70.526C101.58 70.526 104.675 71.1416 107.563 72.3377C108.39 72.6806 109.196 73.0693 109.977 73.5013Z",
    fill: "black",
    fillOpacity: 0.1
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M194.497 53.1395C194.497 50.0139 193.882 46.919 192.686 44.0314C191.49 41.1438 189.736 38.5201 187.526 36.31C185.316 34.1 182.693 32.3468 179.805 31.1507C176.917 29.9547 173.822 29.3391 170.697 29.3391C167.571 29.3391 164.476 29.9547 161.589 31.1507C158.701 32.3468 156.078 34.1 153.867 36.31C151.657 38.5201 149.904 41.1438 148.708 44.0314C147.512 46.919 146.896 50.0139 146.896 53.1395L170.697 53.1395H194.497Z",
    fill: "url(#paint4_linear_187_1802)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M194.497 53.1395C194.497 50.0139 193.882 46.919 192.686 44.0314C191.49 41.1438 189.736 38.5201 187.526 36.31C185.316 34.1 182.693 32.3468 179.805 31.1507C176.917 29.9547 173.822 29.3391 170.697 29.3391C167.571 29.3391 164.476 29.9547 161.589 31.1507C158.701 32.3468 156.078 34.1 153.867 36.31C151.657 38.5201 149.904 41.1438 148.708 44.0314C147.512 46.919 146.896 50.0139 146.896 53.1395L170.697 53.1395H194.497Z",
    fill: "black",
    fillOpacity: 0.1
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 170.697,
    cy: 21.406,
    r: 15.8669,
    fill: "#619D94"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M182.224 32.3153C179.332 35.369 175.239 37.2739 170.701 37.2739C166.164 37.2739 162.071 35.3689 159.179 32.3151C159.959 31.8831 160.765 31.4945 161.593 31.1516C164.481 29.9556 167.576 29.34 170.701 29.34C173.827 29.34 176.922 29.9556 179.809 31.1516C180.637 31.4945 181.443 31.8832 182.224 32.3153Z",
    fill: "url(#paint5_linear_187_1802)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M182.224 32.3153C179.332 35.369 175.239 37.2739 170.701 37.2739C166.164 37.2739 162.071 35.3689 159.179 32.3151C159.959 31.8831 160.765 31.4945 161.593 31.1516C164.481 29.9556 167.576 29.34 170.701 29.34C173.827 29.34 176.922 29.9556 179.809 31.1516C180.637 31.4945 181.443 31.8832 182.224 32.3153Z",
    fill: "black",
    fillOpacity: 0.1
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M260.665 94.3265C260.665 91.201 260.05 88.1061 258.854 85.2185C257.657 82.3309 255.904 79.7072 253.694 77.4971C251.484 75.287 248.86 73.5339 245.973 72.3378C243.085 71.1417 239.99 70.5261 236.865 70.5261C233.739 70.5261 230.644 71.1417 227.757 72.3378C224.869 73.5339 222.246 75.287 220.035 77.4971C217.825 79.7072 216.072 82.3309 214.876 85.2185C213.68 88.1061 213.064 91.201 213.064 94.3265L236.865 94.3265H260.665Z",
    fill: "url(#paint6_linear_187_1802)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M260.665 94.3265C260.665 91.201 260.05 88.1061 258.854 85.2185C257.657 82.3309 255.904 79.7072 253.694 77.4971C251.484 75.287 248.86 73.5339 245.973 72.3378C243.085 71.1417 239.99 70.5261 236.865 70.5261C233.739 70.5261 230.644 71.1417 227.757 72.3378C224.869 73.5339 222.246 75.287 220.035 77.4971C217.825 79.7072 216.072 82.3309 214.876 85.2185C213.68 88.1061 213.064 91.201 213.064 94.3265L236.865 94.3265H260.665Z",
    fill: "black",
    fillOpacity: 0.1
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 236.865,
    cy: 62.5931,
    r: 15.8669,
    fill: "#619D94"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M248.392 73.5013C245.5 76.5551 241.407 78.46 236.869 78.46C232.331 78.46 228.239 76.5551 225.347 73.5014C226.128 73.0693 226.934 72.6807 227.761 72.3378C230.649 71.1417 233.744 70.5261 236.869 70.5261C239.995 70.5261 243.09 71.1417 245.977 72.3378C246.805 72.6807 247.611 73.0693 248.392 73.5013Z",
    fill: "url(#paint7_linear_187_1802)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M248.392 73.5013C245.5 76.5551 241.407 78.46 236.869 78.46C232.331 78.46 228.239 76.5551 225.347 73.5014C226.128 73.0693 226.934 72.6807 227.761 72.3378C230.649 71.1417 233.744 70.5261 236.869 70.5261C239.995 70.5261 243.09 71.1417 245.977 72.3378C246.805 72.6807 247.611 73.0693 248.392 73.5013Z",
    fill: "black",
    fillOpacity: 0.1
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_187_1802",
    x1: 18.2618,
    y1: 29.3391,
    x2: 34.5408,
    y2: 65.8154,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#026051"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B5F59",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#47A092"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_187_1802",
    x1: 25.499,
    y1: 29.3401,
    x2: 29.5931,
    y2: 42.6632,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#026051"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B5F59",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#47A092"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_187_1802",
    x1: 84.4303,
    y1: 70.5261,
    x2: 100.709,
    y2: 107.002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#026051"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B5F59",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#47A092"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_187_1802",
    x1: 91.6669,
    y1: 70.526,
    x2: 95.761,
    y2: 83.8492,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#026051"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B5F59",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#47A092"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_187_1802",
    x1: 156.676,
    y1: 29.3391,
    x2: 172.955,
    y2: 65.8154,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#026051"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B5F59",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#47A092"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_187_1802",
    x1: 163.914,
    y1: 29.34,
    x2: 168.008,
    y2: 42.6631,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#026051"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B5F59",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#47A092"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_187_1802",
    x1: 222.844,
    y1: 70.5261,
    x2: 239.123,
    y2: 107.002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#026051"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B5F59",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#47A092"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_187_1802",
    x1: 230.081,
    y1: 70.5261,
    x2: 234.176,
    y2: 83.8493,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#026051"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B5F59",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#47A092"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivityComingSoon);
export default __webpack_public_path__ + "static/media/activityComingSoon.6382a6b53999064fe10d62c5d81b3a77.svg";
export { ForwardRef as ReactComponent };